import React, {useState, useEffect} from 'react'
import { Chart, LinearScale, BarElement,  CategoryScale, Title, Legend, Tooltip } from "chart.js";
import { Bar } from 'react-chartjs-2';
const WLChart = (props) => {
    const [data, setData] = useState(null);
    const [options, setOptions] = useState(null);

    useEffect(()=>{
        if(props.sznWL.length > 0){
            Chart.register(LinearScale, BarElement,  CategoryScale, Title, Legend, Tooltip );
            // build datasets and labels arrays
            let w = [], l = [], p = [], labels = [];
            for(const szn of props.sznWL){
                labels.push(szn.season);
                w.push(szn.w);
                l.push(szn.l);
                p.push(szn.p);
            };
            // chart options 
            const tmpOptions = {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                scales:{
                    x:{
                        grid:{
                            display:false
                        }
                    },
                    y:{
                        grid:{
                            display:false
                        }
                    }
                }
            };
            setOptions(tmpOptions);

            // data 
            let tmpData = {
                labels: labels,
                datasets: [
                    {
                        backgroundColor:'rgba(21, 184, 108, 0.75)', // Brand green
                        borderWidth: 0,
                        data: w
                    },
                    {
                        backgroundColor:'rgba(229, 57, 53, 0.75)', // Brand red
                        borderWidth: 0,
                        data: l
                    },
                    {
                        backgroundColor:'rgba(75, 85, 99, 0.75)', // Gray-600
                        borderWidth: 0,
                        data: p
                    }
                ] 
            };
            setData(tmpData);
        };
    },[props.sznWL])
    
    if(options && data){
        return (
            <Bar options={options} data={data} />
        );
    }else{
        return(<></>)
    }

};

export default WLChart;